import { useRef, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import UserContext from '../context/UserContext';

const Register = () => {
  const form = useRef({});
  const recaptchaRef = useRef();
  const navigate = useNavigate();
  const { setUser } = useContext(UserContext);

  const register = (e) => {
    e.preventDefault();

    const sendRegistrationData = async () => {
      const token = await recaptchaRef.current.executeAsync();
      recaptchaRef.current.reset();

      const phoneNumber = form.current.phoneNumber.value;

      const data = new FormData();
      data.append('g-recaptcha-response', token);
      data.append('phone', phoneNumber);

      const res = await fetch('/api/user/register', {
        method: 'POST',
        body: data,
      });

      if (res.status) {
        setUser({ phoneNumber });
        navigate('/signin');
      }
      //console.log(res.status);
      //console.log(document.cookie);
    };

    sendRegistrationData();
  };

  // useEffect(() => {});

  return (
    <div className="w-full h-full my-auto flex justify-center items-center">
      <form
        ref={form}
        className="w-96 h-full flex flex-col justify-between items-center p-5 rounded-lg bg-white"
        style={{ direction: 'rtl' }}
        onSubmit={register}
      >
        <h2 className="w-full font-bold text-center text-xl">
          لطفا اطلاعات کاربری خودرا تکمیل کنید
        </h2>
        {/* <div className="flex flex-col justify-between items-start font-semibold">
          <label htmlFor="firstName">:نام</label>
          <input
            className="border-gray-400 border rounded-sm"
            type="text"
            id="firstName"
          />
        </div>
        <div className="flex flex-col justify-between items-start font-semibold">
          <label htmlFor="lastName">:نام خانوادگی</label>
          <input
            className="border-gray-400 border rounded-sm"
            type="text"
            id="lastName"
          />
        </div> */}
        <div className="w-full flex flex-col justify-between items-start font-semibold my-5">
          <label htmlFor="phoneNumber" className="mb-3 text-lg">
            شماره تماس: (مثال : ۹۱۷۱۲۳۴۵۶۷)
          </label>
          <input
            className="w-full border-gray-400 border rounded-lg p-1 px-2 appearance-none"
            type="number"
            id="phoneNumber"
            placeholder="۹"
          />
        </div>

        {/* <div className="w-full flex justify-evenly items-start ">
          <label htmlFor="sex">جنسیت</label>
          <div className="flex justify-center items-center">
            <input type="radio" id="woman" name="drone" value="woman" />
            <label className="h-8" htmlFor="woman">
              مرد
            </label>
          </div>

          <div className="flex justify-center items-center">
            <input type="radio" id="woman" name="drone" value="woman" />
            <label className="h-8" htmlFor="woman">
              زن
            </label>
          </div>
        </div> */}

        <button
          type="submit"
          className="bg-green-500 w-full p-1 rounded-md font-bold"
        >
          ثبت نام
        </button>
      </form>

      <ReCAPTCHA
        // style={{ visibility: 'visible' }}
        ref={recaptchaRef}
        sitekey="6LdtglIgAAAAALbzxz4ERtjWiQBcJOxasSNLIw1I"
        size="invisible"
        badge="bottomright"
      />
    </div>
  );
};

export default Register;
